import Vue from 'vue';
// eslint-disable-next-line
export const adminsEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/admins/adminsEventBus.js